package it.neckar.lizergy.model.financial.currency

import it.neckar.open.unit.time.h
import kotlin.time.Duration

data class MoneyAndTime(
  val money: Money,
  val time: @h Duration,
)
